import { ANALYTICS_ACTIONS } from '../actions/analyticsContextActions';

export interface AnalyticsContextState {
  filters?: {
    selectedFilters?: any;
    filtersData?: any;
    filterValues?: any;
  };
  metrics?: {
    selectedMetrics?: any[];
    selectedAggregate?: any[];
    customColumns?: any[];
  };
  havingFilters?: {
    selectedHavingFilters?: any;
    havingFiltersData?: any;
    havingFilterValues?: any;
  };
  chartOptions?: {
    selectedChartType?: string;
    chartOptionsData?: any;
  };
  underlyingMetrics?: {
    selectedUnderlyingMetrics?: any[];
    selectedSummarizedMetrics?: any[];
  };
  reportMetadata?: {
    selectedReport?: any;
    selectedDataMartType?: string;
    selectedDbType?: string;
    dataMartType?: string;
    reportName?: string;
    reportDescription?: string;
    isAggregated?: boolean;
    metricType?: string;
    isAdminReport?: boolean;
  };
  config?: {
    selectedReportType?: string;
    selectedDashboardType?: string;
    currentSelectedNavTab?: string;
  };
  configData?: {
    selectedReportType?: string;
    selectedDashboardType?: string;
    currentSelectedNavTab?: string;
  };
  customMetrics?: {
    selectedCustomMetrics?: any;
  };
  activeTab?: string;
  lastUpdated?: string;
  lastChangeType?: string;
}

const initialState: AnalyticsContextState = {
  filters: {},
  metrics: {
    selectedMetrics: [],
    selectedAggregate: [],
    customColumns: [],
  },
  havingFilters: {},
  chartOptions: {},
  underlyingMetrics: {
    selectedSummarizedMetrics: [],
    selectedUnderlyingMetrics: [],
  },
  reportMetadata: {},
  config: {},
  customMetrics: {
    selectedCustomMetrics: {},
  },
  activeTab: '',
};

const analyticsContextReducer = (
  state: AnalyticsContextState = initialState,
  action: any
): AnalyticsContextState => {
  switch (action.type) {
    case ANALYTICS_ACTIONS.UPDATE_CONTEXT:
      // Handle complete updates (COMPONENT_MOUNTED) vs partial updates
      if (action.payload.completeUpdate) {
        return {
          ...state,
          ...action.payload.completeUpdate,
        };
      }
      
      // Handle partial updates
      return {
        ...state,
        ...action.payload,
      };

    case ANALYTICS_ACTIONS.RESET_CONTEXT:
      return initialState;

    default:
      return state;
  }
};

export default analyticsContextReducer; 